import React from 'react';
import styled from 'styled-components';
import { UAParser } from 'ua-parser-js';

const uaParser = new UAParser();
const isIE = uaParser.getBrowser().name === 'IE';

const StyledTextarea = styled.textarea<{ placeholderOpacity?: number }>`
  ${({ placeholderOpacity }) =>
    placeholderOpacity
      ? `
      ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        opacity: ${placeholderOpacity}
      }
      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        opacity: ${placeholderOpacity}
      }
      ::-ms-input-placeholder { /* Microsoft Edge */
        opacity: ${placeholderOpacity}
      }
    `
      : null}
`;

interface Props {
  hint?: string;
  value: string;
  onChange: Function;
  onKeyPress?: Function;
  onCmdEnter?: Function;
  rows?: number;
  height?: number;
  width?: number;
  maxlength?: number;
  removeResize?: boolean;
  reference?: any;
  disabled?: boolean;
  hiddenScroll?: boolean;
  style?: Record<string, any>;
  placeholderOpacity?: number;
}

export const InputTextArea = (props: Props) => {
  const {
    hint,
    value,
    onChange,
    rows,
    maxlength,
    removeResize,
    onKeyPress,
    reference,
    disabled,
    hiddenScroll,
    height,
    width,
    style,
    placeholderOpacity,
    onCmdEnter,
  } = props;

  const onKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // cmd + Enter or ctrl + Enter
    if (
      onCmdEnter &&
      event.key === 'Enter' &&
      (event.ctrlKey || event.metaKey)
    ) {
      onCmdEnter();
    }
  };

  return (
    <StyledTextarea
      className="form-control"
      placeholder={hint}
      value={value}
      onChange={(e) => {
        onChange(e.target.value, e);
      }}
      onKeyPress={(e) => {
        if (onKeyPress) {
          onKeyPress(e);
        }
      }}
      onKeyDown={onKeyDown}
      rows={rows}
      ref={reference}
      maxLength={maxlength}
      disabled={disabled}
      style={{
        resize: removeResize ? 'none' : undefined,
        overflowY: hiddenScroll ? 'hidden' : undefined,
        overflowX: 'hidden',
        lineHeight: isIE ? 'normal' : '18px',
        fontSize: '14px',
        padding: '8px',
        height,
        width,
        ...style,
      }}
      placeholderOpacity={placeholderOpacity}
    />
  );
};
